// // components/NotFound.js
// import React from 'react';

// function NotFound() {
//   return (
//     <div
//       style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         width: '100%',
//         backgroundColor: '#f5f5f5',
//         textAlign: 'center',
//         fontFamily: 'Arial, sans-serif',
//       }}
//     >
//       <div>
//         <h1 style={{ fontSize: '4rem', marginBottom: '20px' }}>404</h1>
//         <h2 style={{ fontSize: '2rem', color: '#555' }}>
//           Page Not Found
//         </h2>
//         <p style={{ fontSize: '1rem', color: '#888' }}>
//           Sorry, the page you're looking for doesn't exist.
//         </p>
//       </div>
//     </div>
//   );
// }

// export default NotFound;

import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import { ColorModeContext, tokens } from "../theme";
import { useTheme } from "@mui/material/styles";

const NotFound = () => {
  const theme = useTheme(); // Get the current theme object
  const colors = tokens(theme.palette.mode); // Recalculate colors based on current mode
  const colorMode = useContext(ColorModeContext);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      width="100%"
      bgcolor={colors.primary[400]} // Background color dynamically updates
      textAlign="center"
    >
      <Box>
        <Typography
          variant="h1"
          color={theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[800]}
          marginBottom="20px"
        >
          404
        </Typography>
        <Typography
          variant="h4"
          color={theme.palette.mode === "dark" ? colors.greenAccent[400] : colors.redAccent[400]}
          marginBottom="10px"
        >
          Page Not Found
        </Typography>
        <Typography
          variant="body1"
          color={theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[700]}
          marginBottom="30px"
        >
          Sorry, the page you're looking for doesn't exist.
        </Typography>
        {/* Light/Dark Mode Toggle Button */}
        
      </Box>
    </Box>
  );
};

export default NotFound;
